<template lang="pug">
  main
    NavBarInventario
    ModalDelete(v-show="modalStatusDel" :title="titleModalDel" :content="contentModalDel" @padre:eliminar="deleteTag")
    ModalInfo(v-show="modalStatus" :title="titleModal" :content="contentModal" @padre:close="cerrarModal")
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            p.title Listado de Tags
              | &nbsp
              i.fas.fa-desktop
              | &nbsp
              router-link.a.button.is-dark.is-rounded.is-size-6.is-medium(to="/Inventario/")
                i.fas.fa-times
            a.button.is-primary.is-rounded.is-small(@click="newTag()" v-show="!agregandoTag")
              i.fas.fa-plus
              | &nbsp Agregar Tag
            
        .columns(v-show="hayDatos")
          .column.is-4
            h5.title Tags
            br
            br
            br
            vueCustomScrollbar.scroll-area(:settings="settings" @ps-scroll-y="scrollHanle")
              nav#panelTags.panel
                div(v-for="(data, index) in tags" :key="data.id")
                  a.panel-block.itemsCats(@click="mostrarSubs(data, index)")
                    span.panel-icon
                      i.fas.fa-desktop(aria-hidden='true')
                    |     {{ data.nombre }}
                    | &nbsp
                    a.button.is-danger.is-rounded.is-small(@click="eliminarTag(data)")
                      span.icon.is-small
                        i.fas.fa-times
        .columns
          .column.is-8
            NewTag(@closeTipo="cerrarComponenteTag" v-show="agregandoTag")
            //- ListSubCategorias(:categoriaSel="tagSelected" v-show="mostrandoSubs")

        .columns(v-show="!hayDatos")
          .column.is-4.is-offset-4
            .notification.is-danger No existen Registros aún en la Base de Datos.
        .columns.column-blanco
</template>

<script>
import Loader from '../shared/Loader.vue'
import HeaderInventario from './layout/HeaderInventario.vue'
import NavBarInventario from './layout/NavBarInventario.vue'
import InventarioServices from '../../services/inventario/inventario'
import ModalDelete from '@/components/shared/ModalDelete.vue'
import ModalInfo from '@/components/shared/ModalInfo.vue'
import NewTag from '@/components/inventario_Componentes/NewTag.vue'
// import ListSubCategorias from '@/components/inventario_Componentes/ListSubCategorias.vue'
import vueCustomScrollbar from 'vue-custom-scrollbar'

export default {
  name: 'Tipos',
  components: { Loader, NavBarInventario, HeaderInventario, NewTag, ModalDelete, ModalInfo, vueCustomScrollbar },
  data () {
    return {
      isLoading: true,
      tags: [],
      hayDatos: false,
      agregandoTag: false,
      modalStatusDel: false,
      contentModalDel: '',
      titleModalDel: '',
      tagToDelete: {},
      modalStatus: false,
      contentModal: '',
      titleModal: '',
      tagSelected: {},
      mostrandoSubs: false,
      settings: {
        maxScrollbarLength: 60
      }
    }
  },
  methods: {
    obtenerTags () {
      InventarioServices.getTags()
        .then(res => {
          console.log(res.data)
          if (res.data.length > 0) {
              this.tags = res.data
              this.isLoading = false
              this.hayDatos = true
          } else {
            this.isLoading = false
            this.hayDatos = false
          }
        })
    },
    newTag () {
      this.agregandoTag = true
      this.mostrandoSubs = false
    },
    cerrarComponenteTag () {
      this.agregandoTag = false
      this.obtenerTags()
    },
    mostrarSubs (cat, index) {
      this.unSelectCats()
      let cats = Array.from(document.querySelectorAll('.itemsCats'))
      cats[index].classList.add('is-active')
      this.tagSelected = cat
      this.isLoading = true
      setTimeout(() => {
        this.isLoading = false
        this.mostrandoSubs = true
        this.agregandoTag = false
      }, 500);
    },
    unSelectCats() {
      let cats = Array.from(document.querySelectorAll('.itemsCats'))
      cats.forEach(element => {
        element.classList.remove('is-active')
      });
    },
    eliminarTag(cat) {
      console.log(cat)
      if (cat) {
        this.tagToDelete = cat
        this.titleModalDel = 'Eliminar.'
        this.contentModalDel = `¿Seguro desea eliminar ${cat.nombre}?`
        this.modalStatusDel = true
      }
    },
    deleteTag(result) {
      console.log(result)
      this.modalStatusDel = false
      if (result === 'delete') { 
        this.isLoading = true
        InventarioServices.deleteTag(this.tagToDelete.id)
          .then(data => {
            console.log(data)
            this.isLoading = true
            if (data.success){

              setTimeout(() => {
              this.isLoading = false
              // this.actualizarList = true              
              this.titleModal = 'Categoría Eliminada.'
              this.contentModal = `La categoría ${this.tagToDelete.nombre} se ha Eliminado con Éxito.`
              this.modalStatus = true
              this.isLoading = false
              this.obtenerTags()
              }, 250);
            } else {
              setTimeout(() => {
                this.titleModal = 'Error.'
                this.contentModal = data.respuesta
                this.modalStatus = true
                this.isLoading = false
              }, 250);
            }
          })
      }
    },
    cerrarModal () {
      this.modalStatus = false
    },
    scrollHanle(evt) {
      // console.log(evt)
    }
  }, 
  created () {
    this.obtenerTags()
    setTimeout(() => {
      this.isLoading = false
    }, 2000);
  }
}
</script>

<style scoped>
  #panelTags {
    border: 1px solid #00d1b2;
    background: #ffffff;
  }

  .panel-block {
    border: 1px solid #00d1b2;
  }

  a.panel-block.itemsCats:hover {
    background-color: #c7faf2;
    color: #00d1b2;
  }

  a.panel-block.itemsCats.is-active {
    background-color: #00d1b2;
    color: #ffffff;
  }

  .panel-heading:first-child, .panel-tabs:first-child, .panel-block:first-child {
    border-top: #00d1b2;
  }
  
  .panel-block.is-active .panel-icon {
    color: #ffffff;
  }
  
  .scroll-area {
    position: relative;
    margin: auto;
    height: 400px;
    border-radius: 5px 5px 5px 5px;
    border: 1px solid #00d1b2;
  }
  .ps__thumb-x, .ps__thumb-y {
    background-color: #00d1b2;
    width: 10px;
  }

  .column-blanco {
    padding-bottom: 70px;
  }
  
</style>



// WEBPACK FOOTER //
// src/components/inventario_Componentes/Tags.vue